import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ClientsFilterController', ClientsFilterController);

    function ClientsFilterController(CompaniesFactory, LocalStorageService) {
        var vm = this;

        init();

        function init() {
            CompaniesFactory.readHousingAssociations(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                { page_size: 100 }
            ).then(function (response) {
                vm.dataFromBackend = response.data.results;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/clients-filter/clients-filter.controller.ts